<div class="pagination">
	<cdx-pagination
		*ngIf="canShowPagination(totalItems)"
		[collectionSize]="totalItems"
		[pageSize]="currentPageSize"
		[currentPage]="currentPage"
		(pageChange)="onPageChange($event)"
		[rotate]="true"
	></cdx-pagination>
	<span class="totalItemsCount"> {{ totalItems }} items </span>
</div>
<div class="itemsPerPage" *ngIf="canChangePageSize && (breakPointService.device$ | async) !== device.TABLET">
	<form-dropdown
		labelText="Show:"
		name="itemsperpage-dropdown"
		[list]="itemsPerPageCollection"
		(onSelect)="onPageSizeChange($event)"
		[selectedValue]="currentPageSize"
	></form-dropdown>
	<span class="label">items per page</span>
</div>
